import { useSearchParams } from 'react-router-dom';

import { useFunnel } from '../state/FunnelProvider';

/**
 * The resolved candidate id for the funnel steps (SHOP-6, partial).
 *
 * The meter/address is resolved UP FRONT at the meter step and the opaque
 * `candidateId` lives in `FunnelProvider` — so that is the PRIMARY source. The
 * legacy `?candidate=<id>` URL param is kept as a FALLBACK for back-compat (a
 * plan-first deep link, a refreshed tab whose in-memory store was reset, or the
 * old address hand-off). Kept as a hook (not inline in each page) so the
 * credit / estimate / sign pages resolve the candidate identically.
 */
export function useFunnelCandidateId(): string | undefined {
  const funnel = useFunnel();
  const [searchParams] = useSearchParams();
  return funnel.candidateId ?? searchParams.get('candidate') ?? undefined;
}
